<template>
  <div>
    <v-dialog
      persistent
      v-model="showModalConfirmaBenefDadosAtualizados"
      width="1200"
    >
      <v-card>
        <v-layout
          row
          justify-space-between
          align-center
          class="headline grey lighten-2"
        >
          <v-card-title primary-title>
            {{ `Olá, ${nomeBeneficiario}. Seus dados estão atualizados?` }}
          </v-card-title>
          <v-btn icon @click="setShowModalConfirmaBenefDadosAtualizados(false)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-card-text class="dialog-content">
          <beneficiary-read-only-registration />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :color="highContrast ? 'dark' : 'secondary'"
            @click="confirmar"
          >
            Sim, estão atualizados
          </v-btn>
          <v-btn
            text
            :color="highContrast ? 'dark' : 'primary'"
            @click="updateBeneficarioDados"
          >
            Não, desejo atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import BeneficiaryReadOnlyRegistration from "@/components/BeneficiaryReadOnlyRegistration.vue";
import { gravaHistoricoAtualizacaoCadastral } from "@/services/beneficiario";

const portalStore = createNamespacedHelpers("portal");
const beneficiarioStore = createNamespacedHelpers("beneficiario");

export default {
  name: "ModalConfirmaBenefDadosAtualizados",
  components: {
    BeneficiaryReadOnlyRegistration
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario"]),
    ...portalStore.mapState(["highContrast"]),
    ...portalStore.mapState(["showModalConfirmaBenefDadosAtualizados"]),
    nomeBeneficiario() {
      return this.dadosBeneficiario?.nome ?? "";
    }
  },
  methods: {
    ...portalStore.mapMutations(["setShowModalConfirmaBenefDadosAtualizados"]),
    updateBeneficarioDados() {
      this.$router.push({
        path: "/portal/atualizar-cadastro",
        query: { createDraft: "true" }
      });

      this.setShowModalConfirmaBenefDadosAtualizados(false);
    },
    async confirmar() {
      const payload = {
        codigoBeneficiario: this.dadosBeneficiario.id,
        codigoPessoa: this.dadosBeneficiario.pessoaId
      };

      await gravaHistoricoAtualizacaoCadastral(payload).then(() => {
        this.$store.commit("portal/setToast", "Dados atualizados com sucesso");
        this.setShowModalConfirmaBenefDadosAtualizados(false);
      });
    }
  }
};
</script>

<style scoped>
.dialog-content {
  overflow-y: auto;
  max-height: 60vh;
}
</style>
